/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface OfferSpecification {
  id: number;
  header?: string;
  description?: string;
  totalCount?: number;
  totalCost?: number;
}
